module.exports = __webpack_public_path__ + "static/img/p10.c19d4c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partner/p10.png
// module id = lToZ
// module chunks = 0